// ANGEL FLIGHT — M1: The Overpass (the vertical-slice mission).
//
// Dusk, a ruined suburban overpass. The dead pour out of the haze toward your
// gun. Survive the timer. A gentle escalation: shamblers → runners → a Brute
// skill-check. Pure data; the GameScene drives it.
//
// AC-130 "DON'T HIT FRIENDLIES": from mid-mission, BLUEFOR `trooper`s advance up
// the ramp AMONG the horde. They're hittable but must NOT be shot — a stray round
// is a penalty (combo break + SCRIP dock), and the 3rd downs the mission. They
// thin the fire-everywhere reflex into real target discipline. The lead tints the
// `civilian`-faction unit + IFF-marks it so the player can pick it out.

import type { MissionDef } from '../core/types';

export const overpass: MissionDef = {
  id: 'm1-overpass',
  name: 'The Overpass',
  biome: 'Ruined Suburb — Dusk',
  objective: 'survive',
  theme: 'dusk-suburb',
  durationMs: 90_000,
  brief:
    'Hold the overpass. Friendlies are pushing through the horde — CHECK YOUR FIRE. Nothing reaches the bird.',
  waves: [
    { atMs: 1_200, spawns: { shambler: 4 }, banner: 'CONTACT' },
    { atMs: 11_000, spawns: { shambler: 6, runner: 2 } },
    // BLUEFOR pushes up with the horde — discipline test begins.
    { atMs: 22_000, spawns: { runner: 5, trooper: 1 }, banner: 'FRIENDLIES IN THE OPEN' },
    { atMs: 33_000, spawns: { shambler: 7, runner: 3, trooper: 1 } },
    { atMs: 46_000, spawns: { shambler: 5, runner: 3, brute: 1 }, banner: 'BRUTE' },
    { atMs: 60_000, spawns: { runner: 7, shambler: 6, trooper: 2 } },
    { atMs: 74_000, spawns: { shambler: 8, runner: 5, brute: 1 }, banner: 'THE SURGE' },
  ],
};
